import { FormValidator } from "./FormValidator";
export class FormValidatorFactory {
    constructor(answersService) {
        this.answersService = answersService;
    }
    createValidator(form, instance, answers) {
        return new FormValidator(this.answersService, form, instance, answers);
    }
}
